import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M14.596 1.825a1.2 1.2 0 0 0-.82-.325H4.95a1.2 1.2 0 0 0-1.2 1.2v18.6a1.2 1.2 0 0 0 1.2 1.2h14.1a1.2 1.2 0 0 0 1.2-1.2V7.645a1.2 1.2 0 0 0-.38-.876z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M14.25 1.5v6h6M15.75 12.75h-7.5M15.75 17.25h-7.5"
    }, null, -1)
  ]))]))
}
export default { render: render }